// extracted by mini-css-extract-plugin
export default {"orderTopHeader":"OrderHeader_orderTopHeader__VHCwU","logo":"OrderHeader_logo__tWMg+"};